import React from 'react';

import DynamicModal from '../../Common/DynamicModal';
import CardDetailsBody from './CardDetailsBody';
import { CardDetailsModalProps } from '../../../types/components';

const CardDetailsModal = ({ open, setOpenCardDetailsModal, data, isLocked }: CardDetailsModalProps) => {
  return (
    <DynamicModal
      open={open}
      setClose={setOpenCardDetailsModal}
      showCloseIcon={false}
      body={data ? <CardDetailsBody data={data} setOpenCardDetailsModal={setOpenCardDetailsModal} isLocked={isLocked} /> : null}
      className="show-card-details-modal max-w-400 v3"

    />
  );
}

export default CardDetailsModal;